import React from 'react';
import ProfileSummaryCard from './profileSummaryCard';
import ActivitySummaryCard from './activitySummaryCard';

const SideBar = ({ profileDetails, showActivity, onViewAndUpdateResume, completionPercentage }) => {
  return (
    // Adjusted width and added flex-shrink-0
    <aside className="lg:w-96 flex-shrink-0   h-full overflow-y-auto ">
      <ProfileSummaryCard profile={profileDetails} onViewAndUpdateResume={onViewAndUpdateResume} completionPercentage={completionPercentage} />
      {showActivity && <ActivitySummaryCard activity={profileDetails.activity_summary} />}
    </aside>
  );
};

export default SideBar;